export default "__VITE_ASSET__9cba49a7__"